import React, { useState } from 'react';

const SizeGuide = () => {
  const [selectedCategory, setSelectedCategory] = useState('tops');

  const sizeData = {
    tops: {
      title: "Tops & Tees",
      headers: ['Size', 'Chest (in)', 'Length (in)', 'Shoulder (in)'],
      rows: [
        ['XS', '34-36', '27', '16'],
        ['S', '36-38', '28', '17'],
        ['M', '38-40', '29', '18'],
        ['L', '40-42', '30', '19'],
        ['XL', '42-44', '31', '20'],
        ['XXL', '44-46', '32', '21']
      ]
    },
    outerwear: {
      title: "Outerwear & Jackets",
      headers: ['Size', 'Chest (in)', 'Length (in)', 'Sleeve (in)'],
      rows: [
        ['XS', '36-38', '26', '33'],
        ['S', '38-40', '27', '34'],
        ['M', '40-42', '28', '35'],
        ['L', '42-44', '29', '36'],
        ['XL', '44-46', '30', '37'],
        ['XXL', '46-48', '31', '38']
      ]
    },
    bottoms: {
      title: "Pants & Shorts",
      headers: ['Size', 'Waist (in)', 'Inseam (in)', 'Rise (in)'],
      rows: [
        ['28', '28', '30', '10'],
        ['30', '30', '30', '10.5'],
        ['32', '32', '32', '11'],
        ['34', '34', '32', '11.5'],
        ['36', '36', '32', '12'],
        ['38', '38', '32', '12.5']
      ]
    },
    headwear: {
      title: "Headwear",
      headers: ['Size', 'Circumference (in)', 'Fit'],
      rows: [
        ['One Size', '21-24', 'Adjustable']
      ]
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-medium tracking-wide mb-8">SIZE GUIDE</h1>
      
      {/* Category Tabs */}
      <div className="flex gap-2 mb-8 overflow-x-auto">
        {Object.keys(sizeData).map(category => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={`px-6 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
              selectedCategory === category
                ? 'bg-black text-white'
                : 'border border-gray-300 hover:border-black'
            }`}
          >
            {sizeData[category].title}
          </button>
        ))}
      </div>

      {/* Size Table */}
      <div className="overflow-x-auto mb-12">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-100">
              {sizeData[selectedCategory].headers.map((header, index) => (
                <th
                  key={index}
                  className="border border-gray-300 px-4 py-3 text-left text-sm font-medium"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sizeData[selectedCategory].rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="hover:bg-gray-50">
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className="border border-gray-300 px-4 py-3 text-sm"
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* How to Measure */}
      <div className="space-y-6">
        <h2 className="text-xl font-medium">How to Measure</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="font-medium mb-2">Chest</h3>
            <p className="text-sm text-gray-600">
              Measure around the fullest part of your chest, keeping the tape measure horizontal.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium mb-2">Length</h3>
            <p className="text-sm text-gray-600">
              Measure from the highest point of the shoulder down to the hem.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium mb-2">Shoulder</h3>
            <p className="text-sm text-gray-600">
              Measure from shoulder seam to shoulder seam across the back.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium mb-2">Sleeve</h3>
            <p className="text-sm text-gray-600">
              Measure from the center back of the neck to the end of the sleeve.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium mb-2">Waist</h3>
            <p className="text-sm text-gray-600">
              Measure around your natural waistline, keeping the tape comfortably loose.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium mb-2">Inseam</h3>
            <p className="text-sm text-gray-600">
              Measure from the crotch seam to the bottom of the leg.
            </p>
          </div>
        </div>
      </div>

      {/* Tips */}
      <div className="mt-12 bg-gray-50 p-6 rounded">
        <h3 className="font-medium mb-3">Sizing Tips</h3>
        <ul className="space-y-2 text-sm text-gray-600">
          <li>• Our garments are designed for a relaxed, comfortable fit</li>
          <li>• If you're between sizes, we recommend sizing up</li>
          <li>• All measurements are in inches</li>
          <li>• Measurements may vary by up to 0.5 inches</li>
          <li>• Still unsure? Contact our customer service team for personalized advice</li>
        </ul>
      </div>
    </div>
  );
};

export default SizeGuide;